export const STORE_PRODUCT_GROUP_DEFAULT_LABEL = "Default"
